import React from 'react'
import InputMask from 'react-input-mask'
import { Controller } from 'react-hook-form'
import classNames from 'classnames'

const Date = props => {
  const { field, errors, control } = props
  const { id, label, cssClass } = field
  const hasErrors = errors[id]

  return (
    <div
      className={classNames('fieldContainer', cssClass, { error: hasErrors })}
      key={`field-${id}`}
    >
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <InputMask
            {...field}
            mask="99/99/9999"
            placeholder={label}
            className={classNames({ error: hasErrors })}
          />
        )}
      />

      {hasErrors && (
        <div className="error-message">
          <img src="/themes/thrifty/assets/images/form-error.svg" />
          {errors[id]?.message}
        </div>
      )}
    </div>
  )
}

export default Date
